import regex, { extract } from "../../utils/regex";
import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";
import { StringInputSlim } from "./StringInput";

export default <T,>({ name, label, formik }: IInputProps<T, string>) => {
    return (
        <InputContainer label={label} name={name} formik={formik}>
            <PhoneNumberInputSlim name={name} formik={formik} />
        </InputContainer>
    );
}

export const PhoneNumberInputRow = <T,>({ name, label, formik }: IInputProps<T, string>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <PhoneNumberInputSlim name={name} formik={formik} />
        </InputContainerRow>
    );
}

export const PhoneNumberInputSlim = <T,>({ name, formik }: ISlimInputProps<T, string>) => {
    return (
        <StringInputSlim
            name={name}
            formik={formik}
            onChange={value => ({
                [name]: extract(value, regex.phoneNumber),
            } as Partial<T>)}
        />
    );
}